export default __webpack_public_path__ + "static/media/img-5.052e1cdd.jpg";